import { all } from 'redux-saga/effects';
import { watchApp } from './app.sagas';
import { watchCart } from './cart.sagas';
import { watchCategories } from './category.sagas';
import { watchProducts } from './product.sagas';
import { watchUsers } from './user.sagas';
import { watchSubCategories } from './subCategory.sagas';
import { watchShipping } from './shipping.sagas';

export default function* rootSaga() {
  yield all([
    watchApp(),
    watchCart(),
    watchSubCategories(),
    watchCategories(),
    watchUsers(),
    watchProducts(),
    watchShipping(),
  ]);
}
